
import { useSelector } from "react-redux";
import Interface from "../../../components/DataCollection/Families/ByInterface/InterfaceView/Interface"
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";

const InterfaceViewScreen = () => {
  let react_env = import.meta.env.VITE_ENV; // env-check: intentional
  const userData = useSelector(selectUserData);
  const hasFamiliesScreenPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
     "brands",
     "view_brands"
  );

  return (
    <>
      
      {hasFamiliesScreenPermission  && (react_env === "staging" || react_env === "development") ? ( // env-check: intentional
        <Interface />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default InterfaceViewScreen;
